module.exports = __webpack_public_path__ + "img/q-shanxi.c8de1c60.jpg";